import { render } from "./LoadingScreen.vue?vue&type=template&id=0e9bab41"
const script = {}

import "./LoadingScreen.vue?vue&type=style&index=0&id=0e9bab41&lang=css"

import exportComponent from "/home/mat/gptcube/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__